import BehaviorGenerator from './BehaviorGenerator';
export default (() => BehaviorGenerator().initContent());